import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ExternalLink, Loader2, Sparkles, AlertCircle } from 'lucide-react';
import { api, BACKEND_URL } from '@/lib/api';
import { luxe, gradientCss } from '@/lib/luxe';

export default function PublicApp() {
  const { projectId } = useParams();
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const previewUrl = `${BACKEND_URL}/api/preview/${projectId}/`;

  useEffect(() => {
    api(`/pub/meta/${projectId}`).then(setMeta).catch(() => setMeta({ name: projectId, has_index: false })).finally(() => setLoading(false));
  }, [projectId]);

  return (
    <div className="flex flex-col relative" style={{ height: '100vh', background: luxe.bg, zIndex: 1 }}>
      <div className="flex items-center justify-between px-5 py-3" style={{ background: luxe.bgElev, borderBottom: `1px solid ${luxe.border}` }}>
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center text-base" style={{ background: gradientCss(['#EC4899', '#A855F7']) }}>🌸</div>
          <div>
            <div className="font-display text-base font-black leading-none" style={{ color: luxe.text }}>{meta?.name || projectId}</div>
            <div className="text-[10px] font-bold uppercase tracking-widest mt-0.5 flex items-center gap-1" style={{ color: luxe.muted }}>
              <Sparkles size={10} style={{ color: luxe.gold }} /> Made with <span className="gold-text">MyRaai Studio</span>
            </div>
          </div>
        </div>
        <a href={previewUrl} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-bold" style={{ background: gradientCss(['#4E9EFF', '#6366F1']), color: '#fff' }}>
          Open fullscreen <ExternalLink size={14} />
        </a>
      </div>

      <div className="flex-1 min-h-0" style={{ background: '#fff' }}>
        {loading ? (
          <div className="h-full flex items-center justify-center" style={{ background: luxe.bg }}><Loader2 size={30} className="animate-spin" style={{ color: luxe.pink }} /></div>
        ) : meta?.has_index ? (
          <iframe title={meta?.name || 'app'} src={previewUrl} className="w-full h-full border-0" data-testid="public-app-iframe" />
        ) : (
          <div className="h-full flex items-center justify-center" style={{ background: luxe.bg }}>
            <div className="text-center px-6">
              <div className="mx-auto mb-4 w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: luxe.surface2, border: `1px solid ${luxe.border}` }}><AlertCircle size={26} style={{ color: luxe.muted }} /></div>
              <div className="font-bold" style={{ color: luxe.textMid }}>This app isn’t published yet</div>
              <div className="text-sm mt-1" style={{ color: luxe.muted }}>The owner needs to build & publish it in MyRaai Studio.</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
